import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-card',
    templateUrl: './app-card.component.html'
})
export class AppCardComponent {
    @Input() title: string;
    @Input() nrOfActiveFilters: number;
}
